import { Box } from '@mui/material'
import { ButtonIconSeeker } from '@ui-seeker/core'
import React from 'react'
import { isOpenGroupingExportsModal } from 'Pages/ReportsAlerts/ExportsGrouping/@signals'

export default function infoColumn() {

	return {
		name: 'id',
		label: 'Info',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { exportUrl }) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
					<ButtonIconSeeker
						icon="circle-info"
						iconWeight="light"
						tooltip="More info"
						onClick={() => isOpenGroupingExportsModal.value = value}
					/>
					{!!exportUrl && <ButtonIconSeeker
						icon="down-to-bracket"
						iconWeight="light"
						tooltip="Export URL"
						onClick={e => {
							if (e.ctrlKey) e.preventDefault()
							window.open(exportUrl)
						}}
					/>}
				</Box>
			),
		},
	}
}
